// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"426":"95e7614611f8a0c77c03","888":"6149a5f41ac3f1018260"}[chunkId] + ".css";
};